export default class MatchMedia {
  constructor(callback) {
    this.mediaQuery = '(min-width: 768px)';
    this.callback = callback;
    this.mediaQueryList = window.matchMedia(this.mediaQuery);
    this.isMatched = this.mediaQueryList.matches;
    this.handleMediaQueryChange = this.handleMediaQueryChange.bind(this);
    this.mediaQueryList.addEventListener('change',this.handleMediaQueryChange);

    // 読み込み時に一度だけコールバック関数を実行する
    this.callback(this.isMatched);
  }

  handleMediaQueryChange(mediaQueryList) {
    this.isMatched = mediaQueryList.matches;
    this.callback(this.isMatched);
  }
}
